import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "fixed z-20 inset-0 overflow-y-auto",
    "aria-labelledby": "modal-title",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" };
const _hoisted_3 = { class: "relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" };
const _hoisted_4 = { class: "admin-form panel-form sm:flex sm:items-start" };
const _hoisted_5 = { class: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full" };
const _hoisted_6 = { class: "font-medium text-lg" };
const _hoisted_7 = { class: "text-brand-600" };
const _hoisted_8 = { class: "mt-4" };
const _hoisted_9 = { class: "form-group mb-4 flex items-center" };
const _hoisted_10 = { class: "mt-2 flex-1" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "form-group mb-4 flex items-center" };
const _hoisted_13 = { class: "mt-2 flex-1" };
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "form-group mb-4 flex items-center" };
const _hoisted_16 = { class: "mt-2 flex-1" };
const _hoisted_17 = { class: "form-group mb-4 flex items-center" };
const _hoisted_18 = { class: "mt-2 flex-1" };
const _hoisted_19 = {
    key: 0,
    class: "input-error-message text-sm text-red-600"
};
const _hoisted_20 = { class: "px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)),
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "hidden sm:inline-block sm:align-middle sm:h-screen" }, "​", -1)),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("h2", _hoisted_6, [
                                _cache[8] || (_cache[8] = _createTextVNode("Update Email for Order ", -1)),
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.order.data.reference), 1)
                            ]),
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-slate-400 text-xs" }, "Notification(s) will be resent to the new email address.", -1)),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _cache[9] || (_cache[9] = _createElementVNode("label", {
                                        for: "orderName",
                                        class: "block text-sm font-medium text-gray-700 w-32"
                                    }, "Name", -1)),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("input", {
                                            type: "text",
                                            id: "orderName",
                                            value: _ctx.order.data.name,
                                            class: "form-control block w-full sm:text-sm border-gray-300 rounded-md bg-gray-100 cursor-not-allowed",
                                            disabled: ""
                                        }, null, 8, _hoisted_11)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _cache[10] || (_cache[10] = _createElementVNode("label", {
                                        for: "currentOrderEmail",
                                        class: "block text-sm font-medium text-gray-700 w-32"
                                    }, "Current Email", -1)),
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("input", {
                                            type: "email",
                                            id: "currentOrderEmail",
                                            value: _ctx.order.data.email,
                                            class: "form-control block w-full sm:text-sm border-gray-300 rounded-md bg-gray-100 cursor-not-allowed",
                                            disabled: ""
                                        }, null, 8, _hoisted_14)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _cache[11] || (_cache[11] = _createElementVNode("label", {
                                        for: "newOrderEmail",
                                        class: "block text-sm font-medium text-gray-700 w-32"
                                    }, [
                                        _createTextVNode("New Email"),
                                        _createElementVNode("span", { class: "text-brand-600" }, "*")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_16, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "email",
                                            id: "newOrderEmail",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.newOrderEmail) = $event)),
                                            class: "form-control block w-full sm:text-sm border-gray-300 rounded-md focus:ring-brand-500 focus:border-brand-500",
                                            autocomplete: "off",
                                            onCopy: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["prevent"])),
                                            onPaste: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"]))
                                        }, null, 544), [
                                            [_vModelText, _ctx.newOrderEmail]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _cache[12] || (_cache[12] = _createElementVNode("label", {
                                        for: "confirmNewOrderEmail",
                                        class: "block text-sm font-medium text-gray-700 w-32"
                                    }, [
                                        _createTextVNode("Confirm New Email"),
                                        _createElementVNode("span", { class: "text-brand-600" }, "*")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_18, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "email",
                                            id: "confirmNewOrderEmail",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.confirmNewOrderEmail) = $event)),
                                            class: "form-control block w-full sm:text-sm border-gray-300 rounded-md focus:ring-brand-500 focus:border-brand-500",
                                            autocomplete: "off",
                                            onCopy: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["prevent"])),
                                            onPaste: _cache[5] || (_cache[5] = _withModifiers(() => { }, ["prevent"]))
                                        }, null, 544), [
                                            [_vModelText, _ctx.confirmNewOrderEmail]
                                        ])
                                    ])
                                ]),
                                (_ctx.orderEmailError)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.orderEmailError), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("button", {
                            onClick: _cache[6] || (_cache[6] =
                                //@ts-ignore
                                (...args) => (_ctx.updateOrderEmail && _ctx.updateOrderEmail(...args))),
                            type: "button",
                            class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-brand-600 text-base font-medium text-white hover:bg-brand-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 sm:ml-3 sm:w-auto sm:text-sm"
                        }, " Update "),
                        _createElementVNode("button", {
                            onClick: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                            type: "button",
                            class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 sm:mt-0 sm:w-auto sm:text-sm"
                        }, " Cancel ")
                    ])
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
